import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {browserHistory} from 'react-router';
import Dialog from 'material-ui/Dialog';
import Checkbox from 'material-ui/Checkbox';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';
import * as Colors from 'material-ui/styles/colors';
import InlineButton from 'shared/components/InlineButton';
import routes from 'App/routeConstants';
import {templateService} from 'shared/helpers/TemplateService';
import {closeLazyPanel} from 'crazyEditor/redux/modules/panel/panel';

const saveAsTemplateMonster = require('./Save template monster.svg');
const SHOW_SAVE_AS_TEMPLATE_DIALOG = 'show_save_as_template_dialog';

@connect(
  (state) => ({
    listingData: state.listingData,
    supportApplyTemplateInBulk: state.general.supportLinks.supportApplyTemplateInBulk
  }),
  {closeLazyPanel},
)
export default class SaveAsTemplateDialog extends Component {
  static contextTypes = {
    integrationConnector: PropTypes.object.isRequired,
  };

  componentDidMount() {
    this.showDialog = true;
  }

  toggleShowThisDialog = (event, isInputChecked) => {
    this.showDialog = !isInputChecked;
  };

  goToListingsPage = () => {
    this.handleClose();
    templateService.preventConfirmNavigation();
    browserHistory.push(routes.MyAccount.Listings);
  };

  handleSaveAsTemplate = () => {
    const {integrationConnector} = this.context;
    templateService.saveCurrentTemplate(false, integrationConnector).then(this.goToListingsPage);
  };

  handleClose = () => {
    const {closeLazyPanel, panelName} = this.props;
    localStorage.setItem(SHOW_SAVE_AS_TEMPLATE_DIALOG, JSON.stringify(this.showDialog));
    closeLazyPanel(panelName);
  };

  handleOpen = () => {
    const {open} = this.props;
    if (open) {
      const showDialog = JSON.parse(localStorage.getItem(SHOW_SAVE_AS_TEMPLATE_DIALOG));
      return showDialog === null || showDialog;
    }
    return false;
  };

  render() {
    const {supportApplyTemplateInBulk, open, listingData} = this.props;

    return (
      <Dialog
        open={open && this.handleOpen()}
        onRequestClose={this.handleClose}
      >
        <IconButton
          onClick={this.handleClose}
          iconStyle={{color: Colors.grey800}}
          style={{position: 'absolute', right: 5, top: 5}}
        >
          <FontIcon className="material-icons">close</FontIcon>
        </IconButton>
        <div style={{marginBottom: 20, color: Colors.grey700, display: 'flex'}}>
          <div style={{width: '60%'}}>
            <div style={{marginBottom: 20, fontFamily: 'Acme', fontSize: 50, color: Colors.orange800}}>
              LOOKING GOOD!
            </div>
            <div style={{marginBottom: 20, fontFamily: 'Roboto', fontSize: 16}}>
              Your listing is live,&nbsp;
              <InlineButton href={listingData.viewItemURL} hoverColor="transparent" target="_blank"> see it on eBay. </InlineButton> <br/> <br/>
              Once you save your design as a template, you can apply it to your other listings from the Listings page. <br/> <br/>
              <InlineButton
                href={supportApplyTemplateInBulk}
                hoverColor="transparent"
                target="_blank"
              >
                Read more
              </InlineButton>
              &nbsp;about applying templates to listing
            </div>
            <div style={{bottom: 0}}>
              <Checkbox label="Don’t show this message again" onCheck={this.toggleShowThisDialog}/>
            </div>
          </div>
          <div style={{width: '40%', marginTop: 20}}>
            <img src={saveAsTemplateMonster}/>
          </div>
        </div>
        <div style={{display: 'flex', justifyContent: 'space-between'}}>
          <FlatButton
            primary
            label="DON'T SAVE AND GO TO LISTINGS"
            onClick={this.goToListingsPage}
          />
          <RaisedButton
            primary
            label="SAVE AS TEMPLATE AND GO TO LISTINGS"
            onClick={this.handleSaveAsTemplate}
          />
        </div>
      </Dialog>
    );
  }
}